import type { Template } from "@/types";

export const LA_07_H6_V1: Template[] = [
    {
        id: "la-07-h6v1-01",
        name: "LA 01 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_01.png",
        size: [1352, 541],
        style: {},
        slots: [          
            { id: "1", x: 66, y: 77, width: 280, height: 189, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 274, width: 280, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 354, y: 77, width: 258, height: 386, rotation: 0, imageRotation: 0 },
            { id: "4", x: 737, y: 77, width: 275, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 737, y: 274, width: 275, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1020, y: 77, width: 274, height: 189, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1020, y: 274, width: 274, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-02",
        name: "LA 02 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 103, y: 45, width: 470, height: 300, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 103, y: 353, width: 231, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 353, width: 231, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 759, y: 45, width: 200, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 759, y: 199, width: 200, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 759, y: 353, width: 200, height: 145, rotation: 0, imageRotation: 0 },
            { id: "7", x: 967, y: 45, width: 303, height: 453, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-03",
        name: "LA 03 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 95, y: 58, width: 487, height: 301, rotation: 0, imageRotation: 0 },
            { id: "2", x: 95, y: 367, width: 157, height: 115, rotation: 0, imageRotation: 0 },
            { id: "3", x: 260, y: 367, width: 157, height: 115, rotation: 0, imageRotation: 0 },
            { id: "4", x: 425, y: 367, width: 157, height: 115, rotation: 0, imageRotation: 0 },
            { id: "5", x: 815, y: 58, width: 376, height: 252, rotation: 0, imageRotation: 0 },
            { id: "6", x: 815, y: 318, width: 257, height: 165, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 318, width: 111, height: 165, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-04",
        name: "LA 04 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_04.png",
        size: [1352, 541],
        style: {},
        slots: [          
            { id: "1", x: 118, y: 52, width: 216, height: 141, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 52, width: 216, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 118, y: 201, width: 216, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 201, width: 216, height: 141, rotation: 0, imageRotation: 0 },
            { id: "5", x: 118, y: 350, width: 216, height: 141, rotation: 0, imageRotation: 0 },
            { id: "6", x: 342, y: 350, width: 216, height: 141, rotation: 0, imageRotation: 0 },
            { id: "7", x: 857, y: 52, width: 314, height: 439, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-07-h6v1-05",
        name: "LA 05 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 178, y: 40, width: 320, height: 459, rotation: 0, imageRotation: 0 },
            { id: "2", x: 762, y: 40, width: 329, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 928, y: 274, width: 330, height: 225, rotation: 0, imageRotation: 0 },
            { id: "4", x: 762, y: 274, width: 158, height: 109, rotation: 0, imageRotation: 0 },
            { id: "5", x: 762, y: 391, width: 158, height: 108, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1099, y: 40, width: 158, height: 109, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1099, y: 157, width: 158, height: 109, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-06",
        name: "LA 06 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 79, y: 53, width: 517, height: 320, rotation: 0, imageRotation: 0 },
            { id: "2", x: 79, y: 381, width: 168, height: 109, rotation: 0, imageRotation: 0 },
            { id: "3", x: 255, y: 381, width: 167, height: 109, rotation: 0, imageRotation: 0 },
            { id: "4", x: 430, y: 381, width: 167, height: 109, rotation: 0, imageRotation: 0 },
            { id: "5", x: 742, y: 53, width: 258, height: 438, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1008, y: 53, width: 278, height: 215, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1008, y: 276, width: 278, height: 214, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-07",
        name: "LA 07 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 74, y: 40, width: 292, height: 461, rotation: 0, imageRotation: 0 },
            { id: "2", x: 374, y: 40, width: 217, height: 149, rotation: 0, imageRotation: 0 },
            { id: "3", x: 374, y: 197, width: 217, height: 148, rotation: 0, imageRotation: 0 },
            { id: "4", x: 374, y: 353, width: 217, height: 148, rotation: 0, imageRotation: 0 },        
            { id: "5", x: 768, y: 40, width: 490, height: 306, rotation: 0, imageRotation: 0 },
            { id: "6", x: 768, y: 354, width: 241, height: 148, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1017, y: 354, width: 241, height: 148, rotation: 0, imageRotation: 0 },
           
        ],
    },

    {
        id: "la-07-h6v1-08",
        name: "LA 08 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_08.png",
        size: [1352, 541],
        style: {},
        slots: [      
            { id: "1", x: 74, y: 40, width: 217, height: 149, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 197, width: 217, height: 148, rotation: 0, imageRotation: 0 },
            { id: "3", x: 74, y: 353, width: 217, height: 148, rotation: 0, imageRotation: 0 },
            { id: "4", x: 299, y: 40, width: 292, height: 461, rotation: 0, imageRotation: 0 },
            { id: "5", x: 887, y: 41, width: 254, height: 149, rotation: 0, imageRotation: 0 },
            { id: "6", x: 887, y: 198, width: 254, height: 148, rotation: 0, imageRotation: 0 },
            { id: "7", x: 887, y: 354, width: 254, height: 148, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-09",
        name: "LA 09 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 58, y: 39, width: 304, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 274, width: 304, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 370, y: 39, width: 303, height: 227, rotation: 0, imageRotation: 0 },
            { id: "4", x: 370, y: 274, width: 303, height: 226, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 39, width: 302, height: 461, rotation: 0, imageRotation: 0 },
            { id: "6", x: 991, y: 39, width: 303, height: 227, rotation: 0, imageRotation: 0 },
            { id: "7", x: 991, y: 274, width: 303, height: 226, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-10",
        name: "LA 10 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 58, y: 39, width: 304, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 274, width: 304, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 370, y: 39, width: 303, height: 227, rotation: 0, imageRotation: 0 },
            { id: "4", x: 370, y: 274, width: 303, height: 226, rotation: 0, imageRotation: 0 },         
            { id: "5", x: 681, y: 39, width: 303, height: 227, rotation: 0, imageRotation: 0 },
            { id: "6", x: 681, y: 274, width: 303, height: 226, rotation: 0, imageRotation: 0 },
            { id: "7", x: 992, y: 39, width: 302, height: 461, rotation: 0, imageRotation: 0 }
        ],
    }
];